<div class="homepage-strip__container">
  <div class="homepage-strip__headline">{{featuredContent.name}}</div>
  <div class="homepage-strip__media-items">
    <div class="homepage-strip__media-item" *ngFor="let playlist of featuredContent.items">
      <app-media-item [title]="playlist.name" [subTitle]="playlist.artist" [img]="playlist.img"
                      [routerLink]="['/playlists', playlist.id]"></app-media-item>
    </div>
  </div>
</div>
